import { defineElement, FC, useElement, useListen } from '@atomify/hooks';
import { elements } from '@source/utilities/dom';

const AREA_ACTIVE_STATE = 'header--areas-is-active';

const AreasNavigation: FC = () => {
    const trigger = useElement<HTMLButtonElement>('[js-hook-areas-trigger]', { root: document });
    const close = useElement<HTMLButtonElement>('[js-hook-areas-navigation-close]');
    let areasOpen = false;
    let areasClosedByScroll = false;

    const toggleAreas = (isOpen?: boolean) => {
        if (isOpen === undefined) isOpen = !areasOpen;
        areasOpen = isOpen;
        elements.body.classList.toggle(AREA_ACTIVE_STATE, areasOpen);
    };

    useListen(trigger, 'click', () => toggleAreas());
    useListen(close, 'click', () => toggleAreas(false));
    useListen(window, 'scroll', () => {
        if (areasOpen && window.scrollY > 100) {
            areasClosedByScroll = true;
            toggleAreas(false);
        }

        if (areasClosedByScroll && window.scrollY == 0) {
            areasClosedByScroll = false;
            toggleAreas(true);
        }
    });
};

defineElement('bpd-areas-navigation', AreasNavigation);
